import {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {getImagePathWithThemeSvg} from "../../utils";
import {ConfigProvider, Switch} from 'antd'
import { t } from "i18next";
import {EVENT_SHOW_SNAP_LINE, KEY_GLOBAL_SNAP_LINE_VISIBLE, KEY_USE_SCROLL_WHEEL_ZOOM} from "@/Const";
import {postMessage} from "@/common/event";

const DrawIndexCanvasConfig = forwardRef((props:{callback:any,iShow:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onRefresh:onRefresh
    }))
    const [isUseScrollWheel,setIsUseScrollWheel] = useState(false);
    const [isShowSnapLine,setIsShowSnapLine] = useState(false);

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = ()=>{
        let szVisible = localStorage.getItem(KEY_GLOBAL_SNAP_LINE_VISIBLE) || 'visible';
        setIsShowSnapLine(szVisible == 'visible');

        const szValue: any = localStorage.getItem(KEY_USE_SCROLL_WHEEL_ZOOM);
        setIsUseScrollWheel(szValue == 'true');
    }

    return <div className={'default-font-size'} style={{width: '280px'}}>
        <div className={'flex-row-vertical-center'}>
            <img className={'img-16 '} src={getImagePathWithThemeSvg('draw_setting_scroll_wheel')}/>
            <div className={'flex-col ml-12'}>
                <span className={'font-family-medium font-weight-600'}>{t("UseScrollWheelToZoom")}</span>
                <span className={'mt-4'} style={{color: 'var(--color-9A9A9A)'}}>{t("EnableMouseWheel")}</span>
            </div>
            <div style={{width:'32px',height:'1px'}}></div>
            <ConfigProvider
                theme={{
                    components: {
                        Switch: {
                            /* 这里是你的组件 token */
                            handleSize:16,
                            trackHeight:'20px',
                            trackMinWidth:'36px',
                        },
                    },
                }}
            >
                <Switch value={isUseScrollWheel} style={{width: '32px', marginLeft: 'auto'}} onChange={(e) => {
                    setIsUseScrollWheel(e);
                    if (e) {
                        localStorage.setItem(KEY_USE_SCROLL_WHEEL_ZOOM, 'true');
                    } else {
                        localStorage.removeItem(KEY_USE_SCROLL_WHEEL_ZOOM);
                    }
                    if (props.callback){
                        props.callback('useScrollWheel')
                    }
                }}/>
            </ConfigProvider>

        </div>
        <div className={'line mt-12'} style={{margin: '12px -12px'}}></div>

        <div className={'flex-row-vertical-center'}>
            <img className={'img-16 '} src={getImagePathWithThemeSvg('draw_setting_snapline')}/>
            <div className={'flex-col ml-12'}>
                <span className={'font-family-medium font-weight-600'}>{t("ShowSnapLines")}</span>
                <span className={'mt-4'} style={{color: 'var(--color-9A9A9A)'}}>{t("DisplayAlignmentGuides")}</span>
            </div>
            <div style={{width: '32px', height: '1px'}}></div>
            <ConfigProvider
                theme={{
                    components: {
                        Switch: {
                            /* 这里是你的组件 token */
                            handleSize:16,
                            trackHeight:'20px',
                            trackMinWidth:'36px',
                        },
                    },
                }}
            >
                <Switch value={isShowSnapLine} style={{width: '32px', marginLeft: 'auto'}} onChange={(e) => {
                    setIsShowSnapLine(e);
                    let szVisible = e ? 'visible' : 'invisible';
                    localStorage.setItem(KEY_GLOBAL_SNAP_LINE_VISIBLE, szVisible);
                    postMessage(EVENT_SHOW_SNAP_LINE);
                }}/>
            </ConfigProvider>
        </div>
        <div className={'line mt-12'} style={{margin: '12px -12px'}}></div>

        <div className={'flex-row-vertical-center cursor-pointer'} onClick={(e) => {
            props.callback('backgroundColor')
        }}>
            <img className={'img-16 '} src={getImagePathWithThemeSvg('draw_setting_background')}/>
            <div className={'flex-col ml-12'}>
                <span className={'font-family-medium font-weight-600'}>{t("CanvasBackgroundColor")}</span>
                <span className={'mt-4'} style={{color: 'var(--color-9A9A9A)'}}>{t("ChooseTheBackgroundColor")}</span>
            </div>
            <div style={{width: '32px', height: '1px'}}></div>
            <div className={'flex-center'} style={{width: '44px', height: '44px', flexShrink: '0', marginLeft: 'auto'}}>
                <img className={'img-16 '} src={getImagePathWithThemeSvg('draw_setting_background_edit')}/>
            </div>

        </div>
    </div>
})

export default DrawIndexCanvasConfig;